export default {
  label: 'Páginas',
  placeholder: 'Todas',
  selected: 'seleccionado',
  selectedPlural: 'seleccionados',
};
